/* lua.js generated code 0.3.0 */

require("clover/scene/BaseScene")
require("clover/panel/StartPanel")
require("clover/logic/CloverLogic")
require("clover/data/IntroManager")
require("clover/animation/ui/HomeSceneAnimation")
require("clover/ui/UIConsts")
// require("clover/scene/component/homescene/popoutQueue/HomeScenePopoutQueue")
require("clover/config/LevelType")
require("clover/animation/AnimationCachePool")
require("clover/utils/RandomFactory")
// NOT USED
require("clover/data/PrepropRecordManager")
require("clover/data/GamePlayCacheManager")
// require("clover/data/LevelSeedManager")
// require("clover/clover")
require("clover/data/ReplayManager")
require("clover/gameGuide/GameGuide")
require("clover/data/ItemDataManager")
var LoadingPanel = unpack(require("clover/panel/LoadingPanel"))[0]
var BaseHomeScene = xClass("BaseHomeScene", BaseScene)
var winSize = cc.Director.getInstance().getWinSize()
BaseHomeScene.create = function (isMainHome) {
    var self = this
    var s = BaseHomeScene.new()
    s.name = "BaseHomeScene"
    s.isMainHome = isMainHome
    s.initScene()
    return s
}
BaseHomeScene.prototype.hideBtns = function () {
    var self = this
    if (self.btnLayer){
        self.btnLayer.hidePartBtn(ICON_TYPE.kLeft)
        self.btnLayer.hidePartBtn(ICON_TYPE.kRight)
        
    }  
}
BaseHomeScene.prototype.onInit = function () {
    var self = this
    //---------------------------------test-----------------------------------------
    TEST_HOME_SCENE_ANIM = true
    TEST_HOME_SCENE_SPINE = true
    TEST_HOME_SCENE_WAVE_STAR = true
    TEST_HOME_SCENE_WAVE_3D_ACTION = true
    TEST_HOME_SCENE_WAVE_WAVE_ACTION = true

    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var darkLayer = cc.LayerColor.create(cc.color(0, 0, 0, 255))
    // darkLayer.setOpacity(255)
    darkLayer.setContentSize(visibleSize)
    // darkLayer.setPosition(-visibleSize.width / 2, -visibleSize.height / 2)
    self.addChild(darkLayer, -999)
    quickBuildUIButton(darkLayer, ()=>{
        console.log("click")    
        self.hideBtns()
         
    })
    let color1 = cc.color(44, 177, 237, 255);
    let color2 = cc.color(39, 98, 224, 255);
    // const abTest = MetaManager.getGameCfg().background_ab_test_name;
    // const isNewBg = UserManager.getInstance().getGroupByKey(abTest) == "b";
    // if(isNewBg) {
    //     color1 = cc.color(44, 177, 237, 255);
    //     color2 = cc.color(39, 98, 224, 255);
    // }
    self.background = cc.LayerGradient.create(color1, color2, cc.p(0, -1))
    self.background.changeWidthAndHeight(display.width, display.height)
    self.addChild(self.background, -10)
    self.pageContainer = cc.Node.create()
    self.pageContainer.pos = cc.p((display.width - GamePlayConfig_Design_Width) / 2, (display.height - GamePlayConfig_Design_Height) / 2)
    self.pageContainer.setPosition(self.pageContainer.pos)
    self.addChild(self.pageContainer)
    self.btnLayer = require("clover/scene/component/homescene/HomeSceneBtnLayer").create(self)
    self.addChild(self.btnLayer)
    __DEBUG && $timeStamp('homeSceneBtnLayer done')
    self.cartoonLayer = cc.Node.create()
    self.addChild(self.cartoonLayer)
    var banner = require("clover/scene/component/homescene/HomeSceneInfoBanner").create(self)
    __DEBUG && $timeStamp('HomeSceneInfoBanner done')
    self.addChild(banner)
    self.infoBanner = banner
    self.guideLayer = cc.Node.create()
    self.guideLayer.setLocalZOrder(10000)
    self.addChild(self.guideLayer)
    self.maskLayer = cc.Node.create()
    self.addChild(self.maskLayer)
    self.lastUpdateMessageTime = Localhost.time()
    // var md5 = he.ResManager.getInstance().getFileMd5("src/main.lua")
    // printf("main.lua:%s", md5)
    // CCSpriteEx.isNeedAction = true

    self.hasSentGameLoadStep = false;
}
StartLevelLogicClassLevelRef = table()
StartLevelLogicClassTypeRef = table(
    [1, GameLevelType.kMainLevel, require("clover/gamePlay/startEndLevelLogic/StartMainLevelLogic")],
    [1, GameLevelType.kEditor, require("clover/gamePlay/startEndLevelLogic/StartEditorLevelLogic")],
    [1, GameLevelType.kMysteryIsland, require("clover/gamePlay/startEndLevelLogic/StartMysteryIslandLevelLogic")]

)
BaseHomeScene.prototype.selectLevel = function (id, successCallback, failCallback, wantedId) {
    var self = this
    if (self.isBusy) {
        window.logCenter && logCenter.error(new Error(`selectLevel failed. isBusy=${self.isBusy} id=${id}`), 'selectLevelError')
        if (failCallback) {
            failCallback()
        }
        return 
    }
    //  添加岛屿解锁判断
    if (id === UserManager.getInstance().getUserRef().getTopLevelId() && UserManager.getInstance().topIslandNeedUnlock()) {
        window.logCenter && logCenter.error(new Error(`selectLevel failed. topIslandNeedUnlock id=${id}`), 'selectLevelError')
        if (failCallback) {
            failCallback()
        }
        return;
    }

    var logic, errCode
    if (self.startLevelLogic) {
        window.logCenter && logCenter.error(new Error(`selectLevel failed. startLevelLogic exist id=${id}`), 'selectLevelError')
        if (failCallback) {
            failCallback()
        }
        return 
    }
    if (StartLevelLogicClassLevelRef[id]) {
        [logic, errCode] = StartLevelLogicClassLevelRef[id].create(id, {wantedId: wantedId})
    } else {
        let levelType = LevelType.getLevelTypeByLevelId(id);
        if (!levelType) {
            Toast.make("关卡信息错误，请重试！")
            return
        }
        // levelType = GameLevelType.kMysteryIsland
        // levelType = 35
        // let test = StartLevelLogicClassTypeRef[levelType].new(id, {wantedId: wantedId})
        [logic, errCode] = StartLevelLogicClassTypeRef[levelType].create(id, {wantedId: wantedId});
    }
    if (!logic) {
        if (errCode !== ZooErrorCode.LEVEL_ID_INVALID_START_LEVEL) {
            Toast.make(getText("error.tip." + tostring(errCode)))
        }
        if (failCallback) {
            failCallback()
        }
    } else {
        self.startLevelLogic = logic
        logic.start(function () {
            self.startLevelLogic = null
            if (successCallback) {
                successCallback()
            }
        }, function () {
            self.startLevelLogic = null
            if (failCallback) {
                failCallback()
            }
        })
    }
}
BaseHomeScene.prototype.preloadSound = function () {
    var self = this
    // body
    function onFrameLoadComplete() {
        // body
        cc.log("sound effect preload over~")
    }
    var loader = FrameLoader.new()
    for (var i = 1, v = ResourceConfig.sfx[1]; v; i++, v = ResourceConfig.sfx[i]) {
        loader.add(v, kFrameLoaderType.sfx)
    }
    loader.addEventListener(Events.kComplete, onFrameLoadComplete)
    loader.load()
}
BaseHomeScene.prototype.checkLevelAreaCallback = function () {}
BaseHomeScene.prototype.checkLevelArea = function () {
    var self = this
    var level = UserManager.getInstance().getUserRef().getTopLevelId()
    if (_G.LAST_PLAY_LEVEL_ID && _G.LAST_PLAY_LEVEL_ID + 1 < level) {
        return 
    }
    if (_G.LAST_PLAY_LEVEL_ID && _G.LAST_PLAY_LEVEL_ID <= 9999) {
        self.checkLevelAreaCallback()
    }
}
BaseHomeScene.prototype.requestEnterMainScene = function (forceRefresh) {
    var self = this
    if (forceRefresh || Localhost.time() - self.lastUpdateMessageTime > 30 * 60 * 1000) {
        function onFinish(data) {
            self.lastUpdateMessageTime = Localhost.time()
            UserManager.getInstance().syncMsgAmount(data.data.msgAmount)
            UserManager.getInstance().updateInfo.fromLua(data.data.updateInfo)
            self.btnLayer.update()
        }
        function onError() {}
        var http = EnterMainSceneHttp.new(false)
        http.addEventListener(Events.kComplete, onFinish)
        http.addEventListener(Events.kError, onError)
        http.load()
    }
}
BaseHomeScene.prototype.disableTouchEvent = function () {
    var self = this
    // body
    self.isBusy = true
}
BaseHomeScene.prototype.enableTouchEvent = function () {
    var self = this
    // body
    self.isBusy = false
}
BaseHomeScene.prototype.getEnergyPosition = function () {
    var self = this
    // body
    // WARN: maybe multi result
    return self.infoBanner.getEnergyPosition()
}
BaseHomeScene.prototype.getCoinPosition = function () {
    var self = this
    // WARN: maybe multi result
    return self.infoBanner.getCoinPosition()
}
BaseHomeScene.prototype.getInfoCoinPosition = function () {
    let self = this
    return self.infoBanner.coin_btn.getPosition()
}
BaseHomeScene.prototype.getInfoCashPosition = function () {
    let self = this
    return self.infoBanner.cash_btn.getPosition()
}
BaseHomeScene.prototype.hiddenCoinNum = function () {
    var self = this
    self.infoBanner.coinNumLabel.setVisible(false)
}
BaseHomeScene.prototype.showCoinNum = function () {
    var self = this
    self.infoBanner.coinNumLabel.setVisible(true)
}
BaseHomeScene.prototype.getCashPosition = function () {
    var self = this
    // WARN: maybe multi result
    return self.infoBanner.getCashPosition()
}
BaseHomeScene.prototype.getStarPosition = function () {
    var self = this
    // WARN: maybe multi result
    return self.infoBanner.getStarGroupPosition()
}

BaseHomeScene.prototype.onExit = function () {
    if(this.btnLayer.gameClubButton)
        this.btnLayer.gameClubButton.hide();

    if (this.musicTimeout != null) {
        clearTimeout(this.musicTimeout);
        this.musicTimeout = null;
    }
    this.btnLayer.clearPiggyBankIconInterval();
    BaseScene.prototype.onExit.call(this)
}

BaseHomeScene.prototype.cleanup = function () {
    var self = this
    self.disableTouchEvent()
    BaseScene.prototype.cleanup.call(self)
}

BaseHomeScene.prototype.onEnter = function () {
    var self = this
    cc.log("#######################################onEnter")
    cc.log("BaseHomeScene onEnter")
    BaseScene.prototype.onEnter.call(self)
    self.enableTouchEvent()
    self.btnLayer.update()
    self.infoBanner.updateView()
    // self.preloadSound()
    // self.updateLocation()
    self.requestEnterMainScene()
    if(this.btnLayer.gameClubButton && !PopoutManager.getLastPopoutPanel())
        this.btnLayer.gameClubButton.show()
    self.checkLastLevelRecord()
    GameGuide.getInstance().init()

    HomeScenePopoutQueue.getInstance().trigger(HomeSceneActCondition.kEnterHomeScene)
}
BaseHomeScene.prototype.checkLastLevelRecord = function () {
    UserLevel.getInstance().uploadLastScore()
}
BaseHomeScene.prototype.onSyncFinished = function (event) {
    var self = this
    if (event.data === SyncFinishReason.kRestoreData) {
        if (!self.isBusy) {
            self.updateFriends()
        }
    }
}
BaseHomeScene.prototype.gotoCurrentLevel = function () {}
var isInit = true
BaseHomeScene.prototype.onEnterTransitionDidFinish = function () {
    var self = this
    cc.log("#######################################onEnterTransitionDidFinish")
    cc.log("BaseHomeScene onEnterTransitionDidFinish")
    BaseScene.prototype.onEnterTransitionDidFinish.call(self)
    let exitMainLevelAnim = CacheManager.getInstance().getExitMainLevelAnim()
    let exitMysteryLevelAnim = CacheManager.getInstance().getExitMysteryLevelAnim()

    if (isInit) {
        isInit = false
        LoadingPanel.onEnterHomeScene.call(self)
        HomeScenePopoutQueue.getInstance().trigger(HomeSceneActCondition.kEnterGame)
        GameProxy.getInstance().lazyInit()
        UserShare.getInstance()
        PrepropRecordManager.getInstance()
        
        self.gotoCurrentLevel()
        // FIXME: not deal NotificationReact
        // self.setupNotificationReact()
        
        GlobalEventDispatcher.getInstance().addEventListener(kGlobalEvents.kSyncFinished, self.onSyncFinished)
        UserScore.getInstance().on(UserScoreEvent.NewStar, function () {
            self.requestEnterMainScene(true)
        })
        UserLevel.getInstance().on(UserLevelEvent.StartLevel, function(){
            HomeScenePopoutQueue.getInstance().pause()
            HomeScenePopoutManager.getInstance().popoutStop();
        });
        setTimeOut(function () {

            // 如果 是挑战模式 就不播放动画
            if (_G._skipExitLevelAnim) {
                _G._skipExitLevelAnim = false
                self.exitMainLevelAnim = null
                self.onEnterAfter()
            }else {
                if (exitMainLevelAnim) {
                    self.onExitMainLevel(exitMainLevelAnim)
                    self.playExitMainLevelAnim(exitMainLevelAnim)
                }else if (exitMysteryLevelAnim){
                    self.playExitMysteryLevelAnim(exitMysteryLevelAnim)
                } else {
                    self.onEnterAfter()
                }
            }
        }, 0)
    } else if (exitMainLevelAnim) {
        if (_G._skipExitLevelAnim) {
            _G._skipExitLevelAnim = false
            self.exitMainLevelAnim = null
            self.onEnterAfter()
        }else {
            self.onExitMainLevel(exitMainLevelAnim)
            self.playExitMainLevelAnim(exitMainLevelAnim)
        }
    } else if (exitMysteryLevelAnim) {
        self.playExitMysteryLevelAnim(exitMysteryLevelAnim)
    } else {
        self.onEnterAfter()
        // let GoldTurnLogic = require("activity/GoldTurn/GoldTurnLogic");
        GoldTurnLogic.getInstance().pauseIconTask = false;
        self.checkGoldTurnShipAnim();
    }

    // FIXME: music
    //ReplayManager.getInstance().dcErrorGameReplay()
    if (!_G.kIsNewUser) {
        if (cc.sys.platform === cc.sys.WECHAT_GAME) {
            // HACK: 为了解决小程序IOS静音键无效的问题，应该是微信的锅
            self.musicTimeout = setTimeout(() => {
                MusicPlayer.getInstance().playWorldSceneBgMusic()
            }, 2000)
        } else {
            MusicPlayer.getInstance().playWorldSceneBgMusic()
        }
        
    } 
    // 暂时没有背景音乐
    // if (CacheManager.getInstance().cacheForBindingSuccess) {
    //     CacheManager.getInstance().cacheForBindingSuccess = null
    //     Toast.make("成功绑定数据")
    // }
}
BaseHomeScene.prototype.onEnterAfter = function () {
    var self = this
    cc.log("#######################################onEnterAfter")
    self.checkLevelArea()
    // TODO: ignore shake
    // ShakeManager.getInstance().updateInfo(true)
    EnterGameURL.getInstance().handerRedirect().then(() => {
        HomeScenePopoutManager.getInstance().addPopoutMask();
        HomeScenePopoutQueue.getInstance().executor()
        self.updateFriends()
    })

    // step.100 homeScene完成
    if (!self.hasSentGameLoadStep) {
        // 用户登录上报
        GameProxy.getInstance().reportLogin()
        __DEBUG && $timeStamp('home scene onEnterAfter: 100')
        self.hasSentGameLoadStep = true;

        
        // 发送心跳包
        setInterval(function () {

            // 防止浏览器在后台时也发包
            if (!cc.game._paused) {
               dc.dcUserOnline_104()
            }
        }, DCAssist.heartbeatInterval * 1000)
        dc.dcUserOnline_104()

        //  加载关前道具配置
        ItemDataManager.loadPrePropData()
    }

    GameProxy.getInstance().banSwipeBack()
    UserProduct.getInstance().getProductInfo()
}
function scheduleLocalNotification() {
    //RecallManager.getInstance():updateRecallInfo()
    LocalNotificationManager.getInstance().pocessRecallNotification()
    LocalNotificationManager.getInstance().setEnergyFullNotification()
    LocalNotificationManager.getInstance().validateNotificationTime()
    LocalNotificationManager.getInstance().pushAllNotifications()
}
BaseHomeScene.prototype.onExitMainLevel = function (levelId) {
    var self = this
    cc.log("#######################################onExitMainLevel")
    self.exitMainLevelAnim = levelId
}
BaseHomeScene.prototype.onKeyBackClicked = function () {
    var self = this
    if (__ANDROID) {
        function callPaymentExit(paymentClass) {
            if (paymentClass) {
                function buildCallback(onExit, onCancel) {
                    // WARN: maybe multi result
                    return luajava.createProxy("com.happyelements.android.InvokeCallback", table(
                        [1, "onSuccess", onExit || function (result) { }],
                        [1, "onError", onError || function (errCode, msg) { }],
                        [1, "onCancel", onCancel || function () { }]
                    ))
                }
                var exitCallback = buildCallback(function (obj) {
                    for (var i = 1, v = GameEnterBackgroundAffairClassRef[1]; v; i++, v = GameEnterBackgroundAffairClassRef[i]) {
                        pcall(function () {
                            v.getInstance().onEnterBackground()
                        })
                    }
                    GameProxy.getInstance().exitGame()
                }, function () {
                    self.exitDialog = false
                })
                self.exitDialog = true
                paymentClass.exitGame(exitCallback)
            }
        }
        var pfName = he.StartupConfig.getInstance().getPlatformName()
        if (PlatformConfig.isPlatform(PlatformNameEnum.kCMGame)) {
            var cmgamePayment = luajava.bindClass("com.happyelements.android.operatorpayment.cmgame.CmgamePayment")
            callPaymentExit(cmgamePayment)
        } else if (PlatformConfig.isPlatform(PlatformNameEnum.k189Store)) {
            var telecomPayment = luajava.bindClass("com.happyelements.android.operatorpayment.egame.EgamePayment")
            callPaymentExit(telecomPayment)
        } else if (PlatformConfig.isPlatform(PlatformNameEnum.kOppo)) {
            var oppoProxy = luajava.bindClass("com.happyelements.lib.oppo.OppoProxy")
            callPaymentExit(oppoProxy)
        } else if (PlatformConfig.isBaiduPlatform() && MaintenanceManager.getInstance().isBaiduSdkValid()) {
            if (self.exitDialog) {
                return 
            }
            var baiduProxy = luajava.bindClass("com.happyelements.clover.baidu.BaiduProxy")
            callPaymentExit(baiduProxy)
            self.runAction(cc.Sequence.create(cc.DelayTime.create(1), cc.CallFunc.create(function () {
                self.exitDialog = false
            })))
        } else {
            if (self.exitDialog) {
                return 
            }
            function buildCallback(onSuccess, onError, onCancel) {
                // WARN: maybe multi result
                return luajava.createProxy("com.happyelements.android.InvokeCallback", table(
                    [1, "onSuccess", onSuccess || function (result) { }],
                    [1, "onError", onError || function (errCode, msg) { }],
                    [1, "onCancel", onCancel || function () { }]
                ))
            }
            var snsCallback = buildCallback(function (obj) {
                cc.log("Info - Keypad Callback: sns onSuccess")
                for (var i = 1, v = GameEnterBackgroundAffairClassRef[1]; v; i++, v = GameEnterBackgroundAffairClassRef[i]) {
                    pcall(function () {
                        v.getInstance().onEnterBackground()
                    })
                }
                GameProxy.getInstance().endToLua()
            }, function (errorCode, errExtra) {
                self.exitDialog = false
            }, function () {
                self.exitDialog = false
            })
            var dialogUtil = luajava.bindClass("com.happyelements.android.utils.DialogUtil")
            self.exitDialog = true
            dialogUtil.alertDialog(getText("game.exit.tip"), getText("game.exit.yes"), getText("game.exit.no"), snsCallback)
        }
    } else if (__WIN32) {
        if (!self.win32Back) {
            self.win32Back = true
            Toast.make("もう一度で退出します！")
        } else {
            self.win32Back = false
            Toast.make("嘘だよ！")
        }
    }
}
BaseHomeScene.prototype.updateFriends = function (onSuccess, onFail) {
    var self = this
    FriendManager.getInstance().syncFriendInfo(false, function () {
        onSuccess && onSuccess()
        //NOTO:和产品确认玩吧首页的分享由精力礼包代替，去除邀请有礼
        //self.btnLayer.updataCoinDozenBtn()
        DCAssist.dcForUserDataUpdate()
        // HomeScenePopoutQueue.getInstance().trigger(HomeSceneActCondition.kFriendDataAllReady)
        // HomeScenePopoutQueue.getInstance().executor()
    }, function () {
        onFail && onFail()
        DCAssist.dcForUserDataUpdate()
    })
}
BaseHomeScene.prototype.onEnterForeGround = function () {
    var self = this
    self.updateFriends()
    // ShakeManager.getInstance().updateInfo(true)
    HomeScenePopoutQueue.getInstance().trigger(HomeSceneActCondition.kComeToForeground)
    HomeScenePopoutQueue.getInstance().executor()
    DCAssist.tryDC4EveryDayForeGround("home_scence")
}
BaseHomeScene.prototype.initializeByConfig = function (jsonStr, page) {
    var self = this
    self.updateMap(true)
}
BaseHomeScene.prototype.getWinSize = function () {
    var self = this
    return winSize
}
BaseHomeScene.prototype.refreshGold = function () {
    var self = this
    self.btnLayer.goldBtn.refresh()
}
var _homeScene
BaseHomeScene.getInstance = function () {
    var self = this
    if (!_homeScene) {
        _homeScene = BaseHomeScene.create()
        _homeScene.retain()
    }
    return _homeScene
}
BaseHomeScene.prototype.getInfoBanner = function () {
    var self = this
    return self.infoBanner
}
BaseHomeScene.prototype.updateLocation = function () {}
BaseHomeScene.prototype.isInHomeScene = function () {
    var self = this
    var scene = cc.Director.getInstance().getRunningScene()
    return scene === self
}
BaseHomeScene.prototype.onEnterBackground = function () {
    var self = this
    CacheManager.getInstance().enterBackgroundTime = Localhost.time()
}

BaseHomeScene.prototype.setupNotificationReact = function () {
    var self = this
    table.insert(GameEnterBackgroundAffairClassRef, 2, UserEnergy)
    table.insert(GameEnterForegroundAffairClassRef, 4, UserEnergy)
    table.insert(GameEnterBackgroundAffairClassRef, 3, UserLevelAreaByTime)
    table.insert(GameEnterForegroundAffairClassRef, 4, UserLevelAreaByTime)
}
BaseHomeScene.prototype.setOldScoreCache = function (data) {}
BaseHomeScene.prototype.clearOldScoreCache = function () {}
BaseHomeScene.prototype.updateStarBallAfterPassLevel = function () {
    var self = this
    if (self.infoBanner && type(self.infoBanner.updateStarBallAfterPassLevel) === "function") {
        self.infoBanner.updateStarBallAfterPassLevel()
    }
}
BaseHomeScene.prototype.updateNode = function (levelId) {}

var blinkNames = table(
    "star_eff_yellow",
    "star_eff_yellow",
    "star_eff_orange",
    "star_eff_blue"
)
BaseHomeScene.prototype.getBlinkStar = function (seqID) {
    var self = this
    var container = cc.Node.create()
    var star = cc.Sprite.createWithSpriteFrameName("starFly/" + blinkNames[seqID] + ".png")
    star.setRotation(math.random(0, 360))
    star.setOpacity(math.random(100, 255))
    var actionList = table()
    var action = table()
    table.insert(action, cc.ScaleTo.create(10 / 30, 0.18))
    table.insert(action, cc.RotateBy.create(10 / 30, 105))
    table.insert(actionList, cc.Spawn.create(action))
    table.insert(actionList, cc.CallFunc.create(function () {
        star.removeFromParent(true)
    }))
    star.runAction(cc.Sequence.create(actionList))
    container.addChild(star)
    return container
}
BaseHomeScene.prototype.getBlinkWhiteStar = function () {
    var self = this
    var container = cc.Node.create()
    var star = cc.Sprite.createWithSpriteFrameName("starFly/star_bling1.png")
    star.setRotation(math.random(0, 360))
    star.setOpacity(math.random(100, 255))
    var actionList = table()
    var action = table()
    table.insert(action, cc.ScaleTo.create(10 / 30, 0.18))
    table.insert(action, cc.RotateBy.create(10 / 30, 105))
    table.insert(action, cc.FadeOut.create(10 / 30))
    table.insert(actionList, cc.Spawn.create(action))
    table.insert(actionList, cc.CallFunc.create(function () {
        star.removeFromParent(true)
    }))
    star.runAction(cc.Sequence.create(actionList))
    container.addChild(star)
    return container
}
BaseHomeScene.prototype.showPassStarAnim = function (levelId, score, oldScore, callback) {
    callback()
}
BaseHomeScene.prototype.beforePassLvOnEnterAfter= function (cb,levelId) {
    let self = this
    let callback = ()=>{
        if (self.blockLayeraLevelAnim)self.blockLayeraLevelAnim.setVisible(true)
        if (self.blockLayer)self.blockLayer.setVisible(true)
        cb&&cb()
    }
    GoldElysiumManager.getInstance().checkPopu(true, callback, levelId)

}
BaseHomeScene.prototype.playExitMainLevelAnim = function () {
    var self = this
    var level_to = Math.min(self.exitMainLevelAnim, UserManager.getInstance().getUserRef().getTopLevelId())
    self.exitMainLevelAnim = null
    self.blockLayeraLevelAnim = UIButton.create(cc.Node.create(), true)
    self.blockLayeraLevelAnim.setContentSize(cc.Director.getInstance().getVisibleSize())
    self.addChild(self.blockLayeraLevelAnim, 100000)
    function playJumpHead() {
        if(self.blockLayeraLevelAnim) self.blockLayeraLevelAnim.removeFromParent(true)
        self.blockLayeraLevelAnim = null;
        self.onEnterAfter()
    }
    function onFlyError() {
        HomeScene.getInstance().updateStarBallAfterPassLevel()
        CacheManager.getInstance().cleanPassLevelCache()
        playJumpHead()
        cc.log("occured error -----------------")
        // cc.log(debug.traceback())
    }
    self.scrollToLevel(level_to, function () {
        try {
            self.showPassStar(level_to, playJumpHead)
        } catch (error) {
            cc.error(error)
            onFlyError()
        }
    })
}
BaseHomeScene.prototype.showPassStar = function (levelId, callback, score, oldScore) {
    var self = this
    function onEnd() {
        HomeScene.getInstance().updateStarBallAfterPassLevel()
        CacheManager.getInstance().cleanPassLevelCache()
        if (type(callback) === "function") {
            callback()
        }
    }
    var score = score || CacheManager.getInstance().cacheNewScore
    var oldScore = oldScore || CacheManager.getInstance().cacheOldScore
    // if (!score || !oldScore || type(constellationData) !== "table" || type(constellationData[1]) !== "number" || type(constellationData[2]) !== "number" || type(constellationData[3]) !== "table") {
    if (!score || !oldScore) {
        onEnd()
        return 
    }
    if (score.star <= oldScore.star) {
        onEnd()
        return 
    }
    self.beforePassLvOnEnterAfter(()=>{
        self.showPassStarAnim(levelId, score, oldScore, onEnd)
    },levelId)
}

BaseHomeScene.prototype.playExitMysteryLevelAnim = function (exitMysteryLevelAnim) {
    let self = this
    self.blockLayeraLevelAnim = UIButton.create(cc.Node.create(), true)
    self.blockLayeraLevelAnim.setContentSize(cc.Director.getInstance().getVisibleSize())
    self.addChild(self.blockLayeraLevelAnim, 100000)
    function playJumpHead() {
        if(self.blockLayeraLevelAnim) self.blockLayeraLevelAnim.removeFromParent(true)
        self.blockLayeraLevelAnim = null;
        self.onEnterAfter()
    }
    // 这里判断不是第一次过关就不播放动画 
    let lastPlayMysteryLevel = CacheManager.getInstance().lastPlayMysteryLevel
    if (lastPlayMysteryLevel != MysteryIslandManager.getInstance().getCurrentLevelId()){
        self.beforePassLvOnEnterAfter(()=>{
            self.playMysteryNormalStartBtnAnim(playJumpHead) 
        },exitMysteryLevelAnim)
    }else{
        playJumpHead()
    }
}
BaseHomeScene.prototype.pauseScene = function () {
    let self = this
    self.btnLayer.setVisible(false)
    self.infoBanner.setVisible(false)
}
BaseHomeScene.prototype.resumeScene = function () {
    let self = this
    self.btnLayer.setVisible(true)
    self.infoBanner.setVisible(true)
}
module.exports = BaseHomeScene
